import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { Pill } from '@feathr/components';
import { browserIconMap, EBrowsers } from '@feathr/extender/styles/browser';

export interface IProps {
  readonly browser: keyof typeof EBrowsers;
}

function BrowserChip({ browser }: IProps): JSX.Element {
  const browserIcon = browserIconMap[browser];

  return (
    <Pill prefix={browserIcon ? <FontAwesomeIcon icon={browserIcon} /> : undefined}>
      {EBrowsers[browser] || 'Other'}
    </Pill>
  );
}

export default observer(BrowserChip);
